import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

import Arte1 from 'assets/Home/portfolio/arte1.avif'
import Arte2 from 'assets/Home/portfolio/arte2.avif'
import Arte3 from 'assets/Home/portfolio/arte3.avif'

const Arte = ({ data }: any) => {
    const { isTablet } = useContext(GlobalContext)

    return (
        <>
            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Auction Page
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    마음에 드는 창작물을 검색하고{!isTablet && <br />}
                    정품인증이 검증된  옥션과 함께{!isTablet && <br />}
                    최적의 선택을 하세요.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    아르떼 이용자들은 정품인증을 통해{!isTablet && <br />}
                    창작물의 크기, 작가, 위치 등의 정보를 확인하고{!isTablet && <br />}
                    안전한 경매에 참여할 수 있습니다.
                </motion.h4>

                <motion.img
                    src={Arte1}
                    alt="Arte1"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 tablet:pb-8 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    My Profile
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    내 프로필에서 구매 및 판매 물품{!isTablet && <br />}
                    내역을 확인하고 지갑에서 재화를{!isTablet && <br />}
                    한번에 관리하세요.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    프로필로 이동하시면 내가 구매 및 판매한 물품 내역을{!isTablet && <br />}
                    한번에 확인하실 수 있습니다. 구매 및 판매 물품에{!isTablet && <br />}
                    따른 재화 관리를 내 지갑 서비스로 경험해 보세요.
                </motion.h4>

                <motion.img
                    src={Arte2}
                    alt="Arte2"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>

            <section className='pb-24 container'>
                <motion.h3
                    className='mb-2 text-[#B8B8B8] text-40 tablet:text-2xl'
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    Management System
                </motion.h3>

                <motion.h4
                    className='mb-6 font-semibold text-32 text-black tablet:text-xl'
                    transition={{ delay: 0.2 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    관리자는 통합관리시스템을 통해{!isTablet && <br />}
                    유저, 물품, 및 애플리케이션에 대한 관리를{!isTablet && <br />}
                    한눈에 처리하실 수 있습니다.
                </motion.h4>

                <motion.h4
                    className='mb-6 text-[#656565] tablet:text-lg text-2xl'
                    transition={{ delay: 0.4 }}
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                    신고내역 및 창작물에 대한 배송처리서부터 애플리케이션{!isTablet && <br />}
                    공지사항 및 이벤트 페이지까지 애플리케이션 서비스 전체를{!isTablet && <br />}
                    아우르는 모든 관리를 통합관리시스템을 통해 실현 가능합니다.
                </motion.h4>

                <motion.img
                    src={Arte3}
                    alt="Arte3"
                    initial={START_ANIMATION_PROPERTY}
                    whileInView={END_ANIMATION_PROPERTY}
                    viewport={VIEWPORT_PROPERTY} >
                </motion.img>
            </section>
        </>
    )
}

export default Arte
